<template>
    <div>
        <q-table
            :title="$t('rebit-accounts.total_balances.index')"
            :data="serverData"
            :columns="columns"
            row-key="currency"
            :pagination.sync="serverPagination"
            :loading="loading"
            @request="all"
            :rows-per-page-options="[10, 15, 30, 50, 100]"
            style="box-shadow: none; border: 1px solid #ccc;"
        >
            <template v-slot:top-right="props">
                <q-btn outline :label="$t('refresh')" icon="fas fa-sync" color="input-color" class="q-mr-sm" @click="all({pagination: serverPagination})" :loading="loading">
                    <template v-slot:loading>
                        <q-spinner-dots />
                    </template>
                </q-btn>
            </template>

            <template v-slot:body="props">
                <q-tr :props="props">
                    <q-td key="currency" :props="props">
                        {{props.row.currency}}
                    </q-td>
                    <q-td key="total_actual_balance" :props="props">
                        <currency-format
                            class="inline-block"
                            :value="props.row.total_actual_balance"
                            unit=""
                            hide-zero-decimal
                            hide-white-spaces
                            :decimal-max-length="4"
                        />
                    </q-td>
                    <q-td key="usdt_value" :props="props">
                        <currency-format
                            class="inline-block"
                            :value="props.row.usdt_value"
                            unit="USDT"
                            :decimal-max-length="2"
                        />
                    </q-td>
                    <q-td key="nzd_value" :props="props">
                        <currency-format
                            class="inline-block"
                            :value="props.row.nzd_value"
                            unit="NZD"
                            :decimal-max-length="2"
                        />
                    </q-td>
                </q-tr>
            </template>

            <template v-slot:bottom-row="props">
                <tr class="text-green text-bold">
                    <td class="total-row-borders">{{$t('rebit-accounts.total_balances.total')}}</td>
                    <td class="total-row-borders text-right">-</td>
                    <td class="total-row-borders text-right">
                        <currency-format
                            class="inline-block"
                            :value="total_usdt"
                            unit="USDT"
                            :decimal-max-length="2"
                        />
                    </td>
                    <td class="total-row-borders text-right">
                        <currency-format
                            class="inline-block"
                            :value="total_nzd"
                            unit="NZD"
                            :decimal-max-length="2"
                        />
                    </td>
                </tr>
            </template>
        </q-table>
    </div>
</template>
<script>

import RebitAccount from '../models/RebitAccount.js'
export default {
    name: "TotalBalances",
    props: {
        operatorId: {
            type: Number,
            required: false
        }
    },
    computed: {
        columns() {
            return [
                {name: 'currency', label: this.$t('rebit-accounts.total_balances.currency'), align: 'left', field: 'currency', sortable: false},
                {name: 'total_actual_balance', label: this.$t('rebit-accounts.total_balances.total_actual_balance'), align: 'right', field: 'total_actual_balance', sortable: false},
                {name: 'usdt_value', label: this.$t('rebit-accounts.total_balances.usdt_value'), align: 'right', field: 'usdt_value', sortable: false},
                {name: 'nzd_value', label: this.$t('rebit-accounts.total_balances.nzd_value'), align: 'right', field: 'nzd_value', sortable: false},
            ]
        },
        total_usdt() {
            return this.serverData.reduce((a, b) => a + b.usdt_value, 0)
        },
        total_nzd() {
            return this.serverData.reduce((a, b) => a + b.nzd_value, 0)
        }
    },
    data() {
        return {
            loading: false,
            serverPagination: {
                page: 1,
                sortBy: 'currency',
                rowsPerPage: 15,
                descending: false,
                rowsNumber: 10
            },
            serverData: [],
        }
    },
    methods: {
        all({pagination}) {
          this.loading = true
          RebitAccount.balances(`${this.operatorId ? `operator_id=${this.operatorId}&` : ''}page=${pagination.page}&per_page=${pagination.rowsPerPage}`, ({data, meta}) => {
            this.serverPagination = pagination
            // we also set (or update) rowsNumber
            this.serverPagination.rowsNumber = meta.total
            this.serverData = data
            this.loading = false
          }).catch(error => {
            this.$q.notify({
              message: error.data.error,
              color: 'negative',
              icon: 'fa fa-exclamation-triangle'
            })
            this.loading = false
          })
        }
    },
    beforeCreate() {
      if(! (this.$auth.can('rebit-accounts.list') || this.$auth.can('rebit-accounts.view_filtered_and_edit_real_balance')) ){
        this.$router.push({name: 'dashboard'})
      }
    },
    created() {
    },
    mounted() {
      this.all({
        pagination: this.serverPagination
      })
    },
    updated() {
        this.$emit('result', {usdt: this.total_usdt})
    },
    watch: {},
    components: {},
}
</script>
<style>
  .total-row-borders {
    border-top: 3px double rgb(204, 204, 204) !important;
    border-bottom: 3px double rgb(204, 204, 204) !important;
  }
</style>
